import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetSingleStepTeamEventsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	sport: Types.SportType;
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	language: Types.Scalars['Language']['input'];
}>;

export type GetSingleStepTeamEventsQuery = {
	__typename?: 'Query';
	sportEventMatrix:
		| {
				__typename?: 'SportEventMatrixCompetitionColumns';
				competitions: Array<{
					__typename?: 'SportEventMatrixCompetitionColumn';
					count: number;
					packages: Array<{
						__typename?: 'SportEventMatrixPackageRow';
						count: number;
						package: {
							__typename?: 'Package';
							id: string;
							clearName: string;
							shortName: string;
							packageId: number;
						};
					}>;
					competition: {
						__typename?: 'SportCompetitionV2';
						id: string;
						content: {
							__typename?: 'SportCompetitionContentV2';
							name: string;
							fullPath: string;
							iconUrl?: string | null;
						};
					};
				}>;
		  }
		| { __typename?: 'SportEventMatrixPackageColumns' };
};

export const GetSingleStepTeamEventsDocument = gql`
	query GetSingleStepTeamEvents(
		$country: Country!
		$sport: SportType!
		$filter: SportEventFilter
		$language: Language!
	) {
		sportEventMatrix(country: $country, sport: $sport, filter: $filter, aggregation: COMPETITION_PACKAGE) {
			... on SportEventMatrixCompetitionColumns {
				competitions {
					count
					packages {
						count
						package {
							id
							clearName
							shortName
							packageId
						}
					}
					competition {
						id
						content(country: $country, language: $language) {
							name
							fullPath
							iconUrl
						}
					}
				}
			}
		}
	}
`;
